<span class="btn m-1 btn-{{tag.colorClassName}} text-nowrap">
    <i class="fas fa-tag"></i>
    {{tag.tagTypePrefix != null && tag.tagTypePrefix != '' ? tag.tagTypePrefix + ' | ' : ''}}
    {{tag.tagTypeName}}
</span>
